module.exports = __WEBPACK_EXTERNAL_MODULE_os__;